
const getSaveResultEnums = () => {
    return SaveResultEnums;
};
const getValidationEnums = () => {
    return validationEnums;
};

const getEntityNameEnums = () => {
    return entityNameEnums;
};

const getContactType = () => {
    return ContactType;
};
const getGoodsReceiptStatus = () => {
    return GoodsReceiptStatus;
};
const getGoodsReceiptRSDStatus = () => {
    return GRRSDStatus;
};
const getWarehouseLocationsBalance = () => { 
    return warehouseLocationsBalance;
};

const getVendorBarcodeResult = () => {
    return vendorBarcodeResult
}
let SaveResultEnums = {
    Success: 1,
    Failure: 2,
    Concurrency: 3,
    NotUnique: 4,
    InActive: 5,
    HasChildren: 6,
    HasTransaction: 7,
    RefernceTypeNotSelected: 8,
    HasNoReference: 9,
    HasMoreOneReference: 10,
    RefernceRatioNotValid: 11,
    BiggerThanRatioNotValid: 12,
    AssignnedToWarehouses: 13,
    UnAvailable: 14,
    AssignnedToProducts: 15,
    CantAssignnedToInvalidCategory: 16,
    WarehouseNotAssignedToEmployee: 17,
    ProductNotAssingedWarehouse: 18,
    InValid: 19,
    AssignnedToVendor: 20,
    CantAssignnedToInvalidVendorGroup: 21,
    UnAvailableVendor: 22,
    UnAvailableWarehouse: 23,
    UnAvailableProduct: 24,
    UnAvailableUOM: 25,
    CantAssignnedToInvalidVendor: 26,
    InvalidParent: 27,
    QtyInvalid: 28,
    PreferedDateInvalid: 29,
    NotenoghBalanced: 30,
    WrongStockCountSheet: 31,
    EmptyProductCode: 32,
    NotExistProductCode: 33,
    DuplicatedStockCountSheetRow: 34,
    WrongTrackingMethod: 35,
    BatchNotMatchProductCode: 36,
    BatchNotMatchExpiryDate: 37,
    SerialNotMatchProductCode: 38,
    NegativeSysQuantity: 39,
    NegativeActualQuantity: 40,
    FinanceSaveError: 41,
    SerialQtyNotValid: 42,
    IsDeleted: 43,
    ProductNotPurchased: 44,
    QuantityNotEnough: 45,
    PostedJournalEntry: 46,
    BilledReturnVendor: 47,
    ProductHasRawOfMaterial: 48,
    CanNotDeleteJE: 49,
    NotAssignedProductCodeToWarehouse: 50,
    ProductHasBarcodes: 51,
    ErrorsInFile: 52,
    NoActualDataFound: 53,
    SerialHasTransaction: 54,
    HasDeletedBillOfMaterials: 55,
    WarehouseLocationsNotActiveOrDeleted: 57,
    ProductSerialHasInvalidBarcode: 58,
    DifferenceSystQty: 61,
    WarehouseLocationsFreezed: 70,
    WholeWarehouseIsfreezed: 71,
    WarehouseHasLocation: 72,
    WarehouseHasDefaultLocation: 73,
    LocationHasBalance: 74,
    WarehouseNotActiveOrDeleted: 75,
    ProductInActiveOrDeleted: 76,
    BillOfMaterialsIsUpdatedByAnotherUser: 77,
    BarcodeIsDuplicatedAtDifferentProduct: 78,
    BarcodeIsDuplicated: 79,
    //WarehouseLocationHasLocations : 80,
    ProducedNotBatchExpiryHasTransaction : 80,

    // 20.8.2024 Removed due to [ CR No. 781529 ] That Changed the old concept  
    // WarehouseLocationLinkedToDraftSC: 81,
    HasRSDTransaction: 82,
    BarcodeRelatedToAnotherProduct : 83,
    BarcodeRelatedToDeletedOrInactiveProduct: 84,
    NotValidLengthOfSerial: 85,
	ProducNotAssignToWarehouse: 86,
    IsOffer: 87,
    GLNIsRequired: 88,
    SameCategoryForParent: 89, 
    DuplicatedProductInDraftStockSheetRow: 90,
    ActualCountNotExistORVarianceReasonNotExist: 91
}

let validationEnums = {
    EnName: 1,
    ArName: 2,
    Prefix: 3,
    TaxID: 4,
    VATID: 5,
    Phone: 9,
    Email: 10,
    Link: 11,
    GTINCode: 13,
    GLN: 12,
    SerialNum: 17,
    BatchNum: 18
}
let productType = {
    Stockable: 1,
    NonStockable: 2,
    Service: 3
}

let TrackingMethod = {
    SerialNumber: 1,
    BatchNumber: 2,
    BatchNumberExpiryDate: 3,
    Notracking: 4,
    SerialBatchNumberExpiryDate: 5
}

let entityNameEnums = {
    warehouseCategory: 1,
    productCategory: 2,
    warehouse: 3,
    uOMCategory: 4,
    productUOM: 5,
    salesProductUOM: 6,
    purchaseProductUOM: 7,
    vendorGroup: 8,
    vendor: 11,
    vendorContactPerson: 12,
    stockProductUOM: 13,
    NPHIESCategory: 17,
    NPHIESProductCode : 18
}
let ProductCharacteristics = {
    Purchased: 1,
    Sales: 2,
    Dispensable: 3,
    vital: 4,
    Produced: 5
}

let ContactType = {
    Phone: 1,
    Email: 2,
    Link: 3
}

let actionNamesEnums = {
    DeleteRow: 1,
    DeleteAllRows: 2,
    CancelForm: 3,
    SaveForm: 4,
    UndoReceive: 5,
    UOMChange: 6,
    differentScanBarcode: 7,
    OrderQtyChange: 8,
    NotAvailableBalance: 9,
    Validate: 10,
    Reject: 11,
    WarehouseChange: 12,
    ClassificationsChange: 13,
    // 20.8.2024 Removed due to [ CR No. 781529 ] That Changed the old concept  
    // SetNullQty: 14,
    removeProductCategory: 15,
    checkProductDeletedOrUnassigned: 16,
    ProductExistsInAnotherLocation: 17,
    CheckZeroTotalSystemQty: 18,
    CheckTransferAllFlag: 19,
    ScanWHLocationChange: 20,
    BalancedZeroChange: 20,
    VendorBarcodeNotRelatedToProduct:22,
    VendorBarcodeGtinNotRelatedToPO: 23,
    PrintRTV : 24,
    DeleteManualRow : 25,
    DeleteAutoSaveRow : 26
}

let IRSatusEnums = {
    PendingResponse: 1,
    PendingToReceive: 2,
    Done: 3,
    Rejected: 4
}

let purchaseReqSatus = {
    Draft: 1,
    PendingValidation: 2,
    SentToPurchase: 3,
    RejectedByStockController: 4
}

let transferType = {
    TransferToWarehouse: 1,
    TransferToDepartment: 2,
    DispensOnPatient: 3,
    TransferOutFromIR: 4,
}
let barcodeResult = {
    ValidBarcode: 1,
    BarcodeNotAssignToWarehouse: 2,
    UnavailableBarcode: 3,
    BarcodeForProductNotDispenced: 4,
    NotAvailableBalance: 5,
    InActive: 6,
    ProductHasNotRawMaterial : 7,
    ProductNotRequestedInIR: 8,
    BarcodeNotAssignToLocation :9,
    HaveExpiredDate : 10
}
let reportType = {
    JournalEntry: 100028,
    StockCountDetail: 300071,
}

let StockCountStatus = {
    Draft: 1,
    Completed: 2
}

let GoodsReceiptStatus = {
    Draft: 1,
    Validated: 2
}

let GRRSDStatus = {
    Submitted: 1,
    NotSubmitted: 2,
    PartiallySubmitted: 3,
    Failed: 4,
    NonMedication:5
}

let RSDTransactionType = {
    GoodsReceipt : 1,
    DispenseONPatientTransferOut: 2,
    ReturnToVendorFromGoodsReceipt: 3,
    ReturnToVendor: 4,
    ReturnCancelDispense: 5,
    StockCountDeactivate : 6
}

let taxMeasuringType = {
    Percentage: 1,
    Amount: 2,
    Manual: 3,
}
let transferTransactionStatusEnums = {
    PendingToReceive: 1,
    Received: 2,
    Rejected: 3,
    PartialRejected: 4
}

let dataMigrationTemplateType = {
    ProductCategories: 1,
    Products: 2,
    OpeningBalance: 3,
    VendorGroups: 4,
    Vendors: 5
}
let freezeLocations = {
    wholeWH: 1,
    selectedLocations: 2,
    donotFreeze: 3
}
let freezeType = {
    donotFreeze: 1,
    freeze: 2
}

let internalTransferResult = {
    Success : 1,
    WarehouseNotExist : 2,
    WarehouseIsFreez : 3,
    CurrentEmployeeNotAssignedToWarehouseLocation : 4,
    FromLocationNotExist : 5,
    ToLocationNotExist : 6,
    FromLocationISFreez : 7,
    TOLocationISFreez : 8,
    ProductQtyInvalid : 9,
    OtherException : 10,
    DbConcurrency: 11,
    InValidData: 12,
    ProductNotAssignedToWarehouse: 13,
    ProductInActiveOrDeleted:14

}

let  warehouseLocationsBalance = {
    LocationsHasBalance : 1,
    LocationsHasNotBalance : 2,
    WarehouseHasNotLocation : 3,

}

let  vendorBarcodeResult = {
    NotFoundBarcode : 1,
    BarcodeRelatedToDeletedOrInactiveProduct : 2,
    NotRelatedToPurchaseOrders : 3,
    BarcodeNotAssignToWarehouse: 4,
    BarcodeRelatedToAnotherProduct : 5,
    VendorBarcodeValid:6,
    VendorBarcodeIsDuplicated:7
}


export {
    getSaveResultEnums, getValidationEnums, getEntityNameEnums, productType,
    TrackingMethod, ProductCharacteristics, getContactType, actionNamesEnums,
    purchaseReqSatus, transferType, barcodeResult, IRSatusEnums, reportType,
    StockCountStatus, taxMeasuringType, getGoodsReceiptStatus, transferTransactionStatusEnums,
    dataMigrationTemplateType, freezeLocations, freezeType, internalTransferResult, getWarehouseLocationsBalance,
    getGoodsReceiptRSDStatus, getVendorBarcodeResult, RSDTransactionType
};